import axios from "axios";
import { errorActions } from "../helpers/auth_helper";
import {
  ISitemapPagesAddResponse,
  ISitemapPagesResponse,
} from "../interfaces/sitemap_pages.interface";

const URL = `${process.env.REACT_APP_API_URL}/sitemap-custom-urls/`;

export async function getSitemapPages(): Promise<ISitemapPagesResponse | undefined> {
  return axios
    .get<ISitemapPagesResponse>(URL)
    .then((res) => res?.data)
    .catch((error) => {
      errorActions(error, "Error fetching sitemap pages");
      return undefined;
    });
}

export async function addSitemapPages(
  urls: string[]
): Promise<ISitemapPagesAddResponse | undefined> {
  return axios
    .post<ISitemapPagesAddResponse>(URL, { urls })
    .then((res) => res?.data)
    .catch((error) => {
      errorActions(error, "Error adding sitemap pages");
      return undefined;
    });
}

export async function removeSitemapPage(
  url: string
): Promise<ISitemapPagesResponse | undefined> {
  return axios
    .delete<ISitemapPagesResponse>(URL, { params: { url } })
    .then((res) => res?.data)
    .catch((error) => {
      errorActions(error, "Error removing sitemap page");
      return undefined;
    });
}
